import { call, put, all, takeEvery } from 'redux-saga/effects'

import { GET_CAMPAIGN_GRAPHS, getCampaignGraphsSuccess, getCampaignGraphsFailure } from '../actions/campaignsSummary'

import { getCampaignGraphsService } from '../services/campaignsSummary'

function* campaignsSummaryWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_CAMPAIGN_GRAPHS, getCampaignGraphsWorker)
  ])
}

// PLOP_APPEND_PATTERN_ANCHOR_WORKER

function* getCampaignGraphsWorker({ platform, params }) {
  try {
    const response = yield call(getCampaignGraphsService, platform, params)
    yield put(getCampaignGraphsSuccess(response))
  } catch (e) {
    yield put(getCampaignGraphsFailure(e))
  }
}

export default campaignsSummaryWatcher
